import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { CardTitle } from '@cargomatic/ui';
import CargomaticCollapsibleCard from 'components/v2/CollapsibleCard';
import OrdersActionCreators from '../../../actions/OrdersActionCreators';
import SendDOEmailModal from '../shipments/SendDOEmailModal';
import { Documents } from '../documents/Documents';
import AdminServerActionCreators from '../../../actions/AdminServerActionCreators';
import { orderDocTypes } from '../../../config/documents';
import { ShipmentDocumentList } from './ShipmentDocumentList';

export const OrderDocuments = ({ order, shipments }) => {
  const { t } = useTranslation();
  const [showEmailDeliveryOrderModal, setShowEmailDeliveryOrderModal] =
    useState(false);
  const [selectedDocumentId, setSelectedDocumentId] = useState(null);

  const handleSendEmails = (emails) => {
    OrdersActionCreators.emailCustomDeliveryOrder(
      order._id,
      selectedDocumentId,
      emails,
    );
  };

  const handleShowEmailDeliveryOrderModal = (documentId) => {
    setShowEmailDeliveryOrderModal(true);
    setSelectedDocumentId(documentId);
  };

  const handleHideEmailDeliveryOrderModal = () => {
    setShowEmailDeliveryOrderModal(false);
    setSelectedDocumentId(null);
  };

  return (
    <CargomaticCollapsibleCard
      id="order-documents"
      header={() => <span>{t('ORDER_DOCUMENTS')}</span>}
    >
      <div>
        <Documents
          shipment={order}
          isOrder
          onEmail={handleShowEmailDeliveryOrderModal}
          onUpload={(order, _) => {
            AdminServerActionCreators.uploadOrderDocumentSuccess(order);
          }}
          onUploadFailed={(order, _, e) => {
            AdminServerActionCreators.uploadOrderDocumentFail({
              error: e?.message,
            });
          }}
          shipments={shipments}
          docTypes={orderDocTypes}
          pageNeighbours={0}
        />
      </div>
      <div className="mt-6 mb-4">
        <CardTitle>{t('ASSOCIATED_SHIPMENT_DOCS')}</CardTitle>
      </div>
      <ShipmentDocumentList shipments={shipments} />
      {showEmailDeliveryOrderModal && (
        <SendDOEmailModal
          show={showEmailDeliveryOrderModal}
          onSend={handleSendEmails}
          onHide={handleHideEmailDeliveryOrderModal}
        />
      )}
    </CargomaticCollapsibleCard>
  );
};

OrderDocuments.propTypes = {
  order: PropTypes.object,
};
